import React, { useState, useEffect } from "react";
import Body from "../../Common/Body";
import moment from "moment";
import ContentCard from "../../Common/Layout/ContentCard";
import useFetch from "../../../hooks/useFetch";
import BillingFilters from "./BillingFilters";
import { BillingTable } from "./BillingTable";
import { BillingTotals } from "./BillingTotals";

const Billing = () => {
  moment.locale();
  const [maxPagination, setMaxPagination] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataFetched, setDataFetched] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
    dateUntil: moment().format("YYYY-MM-DD"),
  });

  const { get } = useFetch();

  useEffect(() => {
    setIsLoading(true);
    let url = `/reports/billing?page=${currentPage}&`;
    Object.keys(filters).forEach((key) => {
      url += key + "=" + filters[key] + "&";
    });

    get(url)
      .then(async (res) => {
        setDataFetched(res);
        setMaxPagination(res.total);
      })
      .catch((e) => {
        console.log(e);
        throw new Error(e);
      })
      .finally(() => setIsLoading(false));
  }, [filters, currentPage]);

  const handleSelectedPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Body title={"Reporte de facturación"}>
        <ContentCard>
          <BillingFilters
            filters={filters}
            setFilters={setFilters}
          ></BillingFilters>
          <BillingTotals
            total={dataFetched.total}
            charged={dataFetched.charged}
            gained={dataFetched.gained}
          />
        </ContentCard>
        <ContentCard>
          <BillingTable
            filters={filters}
            setFilters={setFilters}
            isLoading={isLoading}
            maxPagination={maxPagination}
            currentPage={currentPage}
            orders={dataFetched.orders}
            handleSelectedPage={handleSelectedPage}
          ></BillingTable>
        </ContentCard>
      </Body>
    </>
  );
};

export default Billing;
